export default __webpack_public_path__ + "static/media/EightAvePlace.f8675716.jpg";